import { Dispatch, SetStateAction } from 'react';
import FilterRadioButton from '../../../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../../../components/FilterRadioButtonsContainer';
import MyModal from '../../../../../components/Modal';
import useGetGeneralAppData from '../../../../../hooks/useGetGeneralAppData';
import { ActionsPermissionsType, OptionType, SelectActionType } from '../types';

interface IPermissionsOsPageModal {
  pageBeingSettedPermissions: OptionType;
  permissionsOfPageModalShow: boolean;
  setPermissionsOfPageModalShow: Dispatch<SetStateAction<boolean>>;
  selectedActions: ActionsPermissionsType;
  handleActionSelect: (action: SelectActionType) => void;
  handlePermissionsChange: () => void;
}

export default function PermissionsOsPageModal({
  pageBeingSettedPermissions,
  permissionsOfPageModalShow,
  setPermissionsOfPageModalShow,
  selectedActions,
  handleActionSelect,
  handlePermissionsChange,
}: IPermissionsOsPageModal) {
  const { permissions: userPermissions } = useGetGeneralAppData();
  const userPermissionsForPage = userPermissions.find((x) => x.codPag === pageBeingSettedPermissions.pageCode);

  return (
    <MyModal
      show={permissionsOfPageModalShow}
      onClose={() => setPermissionsOfPageModalShow(false)}
      onAction={handlePermissionsChange}
      title={`Alterar permissões para a página ${pageBeingSettedPermissions.pageLabel}`}
      type="action"
      closeButtonLabel="Fechar"
      actionButtonLabel="Confirmar permissões"
      size='lg'
      centeredBody
      modalBody={(
        <FilterRadioButtonsContainer>
          {userPermissionsForPage?.vizualizar && (
            <FilterRadioButton
              selected={!!selectedActions.view}
              onClick={() => handleActionSelect({ action: 'view', isSelected: !selectedActions.view})}
            >
              Visualizar
            </FilterRadioButton>
          )}

          {userPermissionsForPage?.incluir && (
            <FilterRadioButton
              selected={!!selectedActions.add}
              onClick={() => handleActionSelect({ action: 'add', isSelected: !selectedActions.add})}
            >
              Adicionar
            </FilterRadioButton>
          )}

          {userPermissionsForPage?.alterar && (
            <FilterRadioButton
              selected={!!selectedActions.update}
              onClick={() => handleActionSelect({ action: 'update', isSelected: !selectedActions.update})}
            >
              Editar
            </FilterRadioButton>
          )}

          {userPermissionsForPage?.imprimir && (
            <FilterRadioButton
              selected={!!selectedActions.download}
              onClick={() => handleActionSelect({ action: 'download', isSelected: !selectedActions.download})}
            >
              Baixar relatórios
            </FilterRadioButton>
          )}

          {userPermissionsForPage?.excluir && (
            <FilterRadioButton
              selected={!!selectedActions.delete}
              onClick={() => handleActionSelect({ action: 'delete', isSelected: !selectedActions.delete})}
            >
              Deletar
            </FilterRadioButton>
          )}
        </FilterRadioButtonsContainer>
      )}
    />
  );
}
